"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/policyVehicleViewModel',["require", "exports", "knockout", "moment", "services/changeHistoryService", "services/customerSelection"], function (require, exports, ko, moment, changeHistoryService, customerSelection) {
    "use strict";

    var PolicyVehicleViewModel = function () {
        function PolicyVehicleViewModel(vehicle) {
            _classCallCheck(this, PolicyVehicleViewModel);

            this.moment = moment;
            this.originalVehicle = null;
            this.registration = ko.observable('');
            this.model = ko.observable('');
            this.make = ko.observable('');
            this.year = ko.observable('');
            this.colour = ko.observable('');
            this.allocatedDate = ko.observable(null);
            this.terminatedDate = ko.observable(null);
            this.isActive = ko.observable(false);
            this.distanceQuota = ko.observable('');
            this.actualDistance = ko.observable('');
            this.created = ko.observable('');
            this.creator = ko.observable('');
            this.modified = ko.observable('');
            this.modifier = ko.observable('');
            this.motExpiryDate = ko.observable(null);
            this.taxExpiryDate = ko.observable(null);
            this.dateOfLastV5CIssued = ko.observable(null);
            this.hasTaxExpired = ko.pureComputed(this.computeHasTaxExpired, this);
            this.hasMotExpired = ko.pureComputed(this.computeHasMotExpired, this);
            this.dvlaRecordNotFound = ko.observable(false);
            this.dvsaRecordNotFound = ko.observable(false);
            this.vehicleHistory = ko.observableArray([]);
            this.registrationValidationEnabled = ko.observable(false);
            this.makeValidationEnabled = ko.observable(false);
            this.modelValidationEnabled = ko.observable(false);
            this.yearValidationEnabled = ko.observable(false);
            this.colourValidationEnabled = ko.observable(false);
            this.allocatedDateValidationEnabled = ko.observable(false);
            this.terminatedDateValidationEnabled = ko.observable(false);
            this.originalVehicle = vehicle;
            this.setProperties(vehicle);
            this.setValidationRules();
            this.setupValidationSubscriptions();
        }

        _createClass(PolicyVehicleViewModel, [{
            key: "getHistory",
            value: function getHistory() {
                changeHistoryService.getVehicleHistory(this.id, this.policyVehicleId).done(function (vehicleHistory) {
                    this.vehicleHistory(vehicleHistory);
                }.bind(this));
            }
        }, {
            key: "resetValues",
            value: function resetValues() {
                this.setProperties(this.originalVehicle);
                this.registrationValidationEnabled(false);
                this.makeValidationEnabled(false);
                this.modelValidationEnabled(false);
                this.yearValidationEnabled(false);
                this.colourValidationEnabled(false);
            }
        }, {
            key: "validate",
            value: function validate() {
                this.registrationValidationEnabled(true);
                this.makeValidationEnabled(true);
                this.modelValidationEnabled(true);
                this.yearValidationEnabled(true);
                this.colourValidationEnabled(true);
                return this.isValid();
            }
        }, {
            key: "setProperties",
            value: function setProperties(policyVehicle) {
                this.id = policyVehicle.id;
                this.policyVehicleId = policyVehicle.policyVehicleId;
                this.registration(policyVehicle.registration);
                this.model(policyVehicle.model);
                this.make(policyVehicle.make);
                this.year(policyVehicle.year);
                this.colour(policyVehicle.colour);
                this.allocatedDate(policyVehicle.allocatedDate ? new Date(policyVehicle.allocatedDate) : null);
                this.terminatedDate(policyVehicle.terminatedDate ? new Date(policyVehicle.terminatedDate) : null);
                this.isActive(policyVehicle.isActive);
                this.distanceQuota(this.metresToMiles(policyVehicle.distanceQuota));
                this.actualDistance(this.metresToMiles(policyVehicle.actualDistance));
                this.created(policyVehicle.created);
                this.creator(policyVehicle.creator);
                this.modified(policyVehicle.modified);
                this.modifier(policyVehicle.modifier);
                this.taxExpiryDate(policyVehicle.taxExpiryDate ? new Date(policyVehicle.taxExpiryDate) : null);
                this.motExpiryDate(policyVehicle.motExpiryDate ? new Date(policyVehicle.motExpiryDate) : null);
                this.dateOfLastV5CIssued(policyVehicle.dateOfLastV5CIssued ? new Date(policyVehicle.dateOfLastV5CIssued) : null);
                this.getDvlaInfo(policyVehicle);
            }
        }, {
            key: "getDvlaInfo",
            value: function getDvlaInfo(policyVehicle) {
                var _this = this;

                if (this.shouldGetDvlaInfo(policyVehicle)) {
                    customerSelection.getDvlaInfoForVehicle(this.registration(), this.id, moment(this.motExpiryDate()).format('YYYY-MM-DDTHH:mm:ss'), moment(this.taxExpiryDate()).format('YYYY-MM-DDTHH:mm:ss'), moment(this.dateOfLastV5CIssued()).format('YYYY-MM-DDTHH:mm:ss')).then(function (dvlaInfo) {
                        if (dvlaInfo) {
                            _this.taxExpiryDate(dvlaInfo.taxExpiryDate ? new Date(dvlaInfo.taxExpiryDate) : null);
                            _this.motExpiryDate(dvlaInfo.motExpiryDate ? new Date(dvlaInfo.motExpiryDate) : null);
                            _this.dateOfLastV5CIssued(dvlaInfo.dateOfLastV5CIssued ? new Date(dvlaInfo.dateOfLastV5CIssued) : null);
                            if (!_this.taxExpiryDate()) {
                                _this.dvlaRecordNotFound(true);
                            }
                            if (!_this.motExpiryDate()) {
                                _this.dvsaRecordNotFound(true);
                            }
                        } else {
                            _this.taxExpiryDate(policyVehicle.taxExpiryDate ? new Date(policyVehicle.taxExpiryDate) : null);
                            _this.motExpiryDate(policyVehicle.motExpiryDate ? new Date(policyVehicle.motExpiryDate) : null);
                            _this.dateOfLastV5CIssued(policyVehicle.dateOfLastV5CIssued ? new Date(policyVehicle.dateOfLastV5CIssued) : null);
                        }
                    });
                } else {
                    this.taxExpiryDate(policyVehicle.taxExpiryDate ? new Date(policyVehicle.taxExpiryDate) : null);
                    this.motExpiryDate(policyVehicle.motExpiryDate ? new Date(policyVehicle.motExpiryDate) : null);
                    this.dateOfLastV5CIssued(policyVehicle.dateOfLastV5CIssued ? new Date(policyVehicle.dateOfLastV5CIssued) : null);
                }
            }
        }, {
            key: "shouldGetDvlaInfo",
            value: function shouldGetDvlaInfo(policyVehicle) {
                if (this.registration() === 'V133 EGO' || this.registration() === 'PAU53D') {
                    return false;
                }
                if (this.isActive()) {
                    if (!policyVehicle.motExpiryDate || new Date(policyVehicle.motExpiryDate) <= new Date()) {
                        return true;
                    }
                    if (!policyVehicle.taxExpiryDate || new Date(policyVehicle.taxExpiryDate) <= new Date()) {
                        return true;
                    }
                    if (!policyVehicle.dateOfLastV5CIssued) {
                        return true;
                    }
                }
                return false;
            }
        }, {
            key: "computeHasTaxExpired",
            value: function computeHasTaxExpired() {
                return this.taxExpiryDate() ? this.taxExpiryDate() <= new Date() : false;
            }
        }, {
            key: "computeHasMotExpired",
            value: function computeHasMotExpired() {
                var today = new Date();
                var priorDate = new Date(new Date().setDate(today.getDate() - 30)); // Temporary fudge while DVSA API is sending crappy data
                if (this.motExpiryDate() < priorDate) {
                    return false;
                }
                return this.motExpiryDate() ? this.motExpiryDate() < today : false;
            }
        }, {
            key: "setValidationRules",
            value: function setValidationRules() {
                this.registration.extend({
                    required: { onlyIf: this.registrationValidationEnabled }
                });
                this.make.extend({
                    required: { onlyIf: this.makeValidationEnabled }
                });
                this.model.extend({
                    required: { onlyIf: this.modelValidationEnabled }
                });
                this.year.extend({
                    required: { onlyIf: this.yearValidationEnabled }
                });
                this.colour.extend({
                    required: { onlyIf: this.colourValidationEnabled }
                });
                this.allocatedDate.extend({
                    required: { onlyIf: this.allocatedDateValidationEnabled },
                    date: { onlyIf: this.allocatedDateValidationEnabled },
                    max: {
                        params: this.terminatedDate,
                        onlyIf: this.allocatedDateValidationEnabled
                    }
                });
                this.terminatedDate.extend({
                    date: { onlyIf: this.terminatedDateValidationEnabled },
                    min: {
                        params: this.allocatedDate,
                        onlyIf: this.terminatedDateValidationEnabled
                    }
                });
                this.isValid = ko.validatedObservable(this).isValid;
            }
        }, {
            key: "setupValidationSubscriptions",
            value: function setupValidationSubscriptions() {
                this.registrationSubscription = this.registration.subscribe(function () {
                    this.registrationValidationEnabled(false);
                }, this);
                this.makeSubscription = this.make.subscribe(function () {
                    this.makeValidationEnabled(false);
                }, this);
                this.modelSubscription = this.model.subscribe(function () {
                    this.modelValidationEnabled(false);
                }, this);
                this.yearSubscription = this.year.subscribe(function () {
                    this.yearValidationEnabled(false);
                }, this);
                this.colourSubscription = this.colour.subscribe(function () {
                    this.colourValidationEnabled(false);
                }, this);
                this.allocatedDateSubscription = this.allocatedDate.subscribe(function () {
                    this.allocatedDateValidationEnabled(false);
                }, this);
                this.terminatedDateSubscription = this.terminatedDate.subscribe(function () {
                    this.terminatedDateValidationEnabled(false);
                }, this);
            }
        }, {
            key: "clearValue",
            value: function clearValue(observable) {
                observable('');
            }
        }, {
            key: "newDate",
            value: function newDate(observable) {
                observable(new Date());
            }
        }, {
            key: "metresToMiles",
            value: function metresToMiles(metres) {
                return (metres / 1609.34).toFixed(0);
            }
        }, {
            key: "dateConfig",
            value: function dateConfig(observable, minDate, maxDate) {
                var config = {
                    type: 'datetime',
                    max: new Date(),
                    value: observable,
                    dateOutOfRangeMessage: '',
                    displayFormat: {
                        parser: function parser(e) {
                            var dateTimeParts = e.split(' ');
                            var dateParts = dateTimeParts[0].split('/');
                            var timeParts = dateTimeParts[1].split(':');
                            return new Date(dateParts[2], dateParts[1], dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
                        },
                        formatter: function formatter(value) {
                            return moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss');
                        }
                    }
                };
                if (minDate) {
                    config['min'] = minDate;
                }
                if (maxDate) {
                    config['max'] = maxDate;
                }
                return config;
            }
        }, {
            key: "registrationValidation",
            value: function registrationValidation() {
                return {
                    validationRules: [{
                        type: 'required',
                        message: 'Registration is required'
                    }]
                };
            }
        }, {
            key: "dispose",
            value: function dispose() {
                this.registrationSubscription.dispose();
                this.makeSubscription.dispose();
                this.modelSubscription.dispose();
                this.yearSubscription.dispose();
                this.colourSubscription.dispose();
                this.allocatedDateSubscription.dispose();
                this.terminatedDateSubscription.dispose();
            }
        }]);

        return PolicyVehicleViewModel;
    }();

    return PolicyVehicleViewModel;
});
//# sourceMappingURL=policyVehicleViewModel.js.map;
